import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import mainImage from "../../static/media/CorporalStetic/main.webp";

const PRIMARY = "#06BBC7";
const BLACK = "#111827";
const YELLOW = "#F7C948";
const YELLOW_HOVER = "#efbd35";

const BodyAestheticsHero = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        pt: { xs: 3, md: 5 },
        pb: { xs: 5, md: 8 },
        background:
          "linear-gradient(180deg, rgba(6, 187, 199, 0.08) 0%, #ffffff 34%, #ffffff 100%)",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            position: "relative",
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.9fr 1fr" },
            alignItems: "center",
            justifyItems: "center",
            gap: { xs: 3.5, md: 5 },
          }}
        >
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -28 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.75, ease: "easeOut" }}
            sx={{
              order: { xs: 2, md: 1 },
              textAlign: "center",
              maxWidth: { xs: 640, md: 620 },
              mx: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#1d2530",
                fontSize: {
                  xs: "2.2rem",
                  sm: "2.8rem",
                  md: "3.5rem",
                },
                fontWeight: 500,
                lineHeight: 1.05,
                letterSpacing: "-0.055em",
                mb: { xs: 2.2, md: 2.8 },
              }}
            >
              Define tu silueta con tratamientos corporales personalizados
            </Typography>

            <Typography
              sx={{
                color: "#374151",
                fontSize: { xs: "1rem", md: "1.08rem", lg: "1.14rem" },
                lineHeight: 1.85,
                fontWeight: 400,
                maxWidth: 590,
                mx: "auto",
                mb: { xs: 2.2, md: 2.6 },
              }}
            >
              Aplicamos técnicas estéticas enfocadas en mejorar la apariencia del
              cuerpo, trabajar zonas específicas y acompañar tu proceso con
              protocolos seguros, modernos y adaptados a tus objetivos.
            </Typography>

            <Typography
              sx={{
                color: "#4b5563",
                fontSize: { xs: "1rem", md: "1.08rem", lg: "1.14rem" },
                lineHeight: 1.85,
                fontWeight: 400,
                maxWidth: 560,
                mx: "auto",
                mb: { xs: 3, md: 3.4 },
              }}
            >
              Cada sesión se realiza con atención profesional, evaluación previa
              y aparatología estética seleccionada según tus necesidades, buscando
              resultados visibles sin perder naturalidad.
            </Typography>

            <Button
              component="a"
              href="/agendar-cita"
              variant="contained"
              sx={{
                bgcolor: YELLOW,
                color: BLACK,
                px: { xs: 3.5, md: 4.4 },
                py: 1.25,
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: 800,
                fontSize: { xs: "0.96rem", md: "1rem" },
                boxShadow: "none",
                "&:hover": {
                  bgcolor: YELLOW_HOVER,
                  color: BLACK,
                  boxShadow: "none",
                },
              }}
            >
              Empezar mi cambio
            </Button>
          </Box>

          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 32, scale: 0.98 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.28 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            sx={{
              order: { xs: 1, md: 2 },
              position: "relative",
              minHeight: { xs: 300, sm: 360, md: 500 },
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: { xs: 250, sm: 350, md: 470, lg: 560 },
                height: { xs: 250, sm: 350, md: 470, lg: 560 },
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(6, 187, 199, 0.2) 0%, rgba(6, 187, 199, 0.08) 48%, rgba(255,255,255,0) 72%)",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />

            <Box
              sx={{
                position: "relative",
                width: { xs: "94%", sm: "84%", md: "100%" },
                maxWidth: { xs: 430, sm: 560, md: 700 },
                overflow: "hidden",
                borderRadius: { xs: "24px", md: "32px" },
                boxShadow: "0 18px 46px rgba(15, 23, 42, 0.1)",
              }}
            >
              <Box
                component="img"
                src={mainImage}
                alt="Tratamiento corporal con aparatología estética"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: { xs: 260, sm: 340, md: 430, lg: 470 },
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block",
                }}
              />
            </Box>

            <Box
              sx={{
                position: "absolute",
                right: { xs: "1%", md: "-1%" },
                bottom: { xs: "4%", md: "8%" },
                width: { xs: 150, sm: 220, md: 300 },
                height: { xs: 150, sm: 220, md: 300 },
                borderRadius: "50%",
                bgcolor: "rgba(6, 187, 199, 0.08)",
                filter: "blur(2px)",
                zIndex: 0,
              }}
            />
          </Box>

          <Box
            sx={{
              order: { xs: 3, md: 3 },
              gridColumn: { xs: "1", md: "1 / -1" },
              width: { xs: 190, sm: 260, md: 340 },
              mx: "auto",
              mt: { xs: 1.5, md: 2 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1.5,
              color: PRIMARY,
            }}
          >
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 28, sm: 34 },
                lineHeight: 1,
                color: PRIMARY,
                fontWeight: 300,
              }}
            >
              ✽
            </Typography>
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BodyAestheticsHero;